import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { AbstractRestService } from 'src/app/shared/types/AbstractRestService';
import { HttpService } from '../http.service';
import { AccreditationDto } from 'src/app/shared/models/AccreditationDto.model';

@Injectable({
  providedIn: 'root'
})
export class AccreditationDataService extends AbstractRestService<any, any>{
  protected baseEndpoint$: Observable<string> = of('accreditation');

  constructor(
    protected http: HttpService,
  ) { 
    super(http);
  }

  public getById(accreditationId:number):Observable<AccreditationDto>{
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.getTyped<AccreditationDto>(`${baseUrl}/${accreditationId}`))
    );
  }

  public isRequireAccreditation():Observable<boolean>{
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.getTyped<boolean>(`${baseUrl}/require-accreditation`))
    );
  }

  public create(model:AccreditationDto):Observable<AccreditationDto>{
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.postTyped<AccreditationDto>(baseUrl, model))
    );
  }

  public sendAccreditationRequestToLp(model:AccreditationDto):Observable<AccreditationDto>{
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.postTyped<AccreditationDto>(`${baseUrl}/accreditation-request`, model))
    );
  }

  public sendManualAccreditation(model:AccreditationDto):Observable<AccreditationDto>{
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.postTyped<AccreditationDto>(`${baseUrl}/manual-accreditation`, model))
    );
  }

  public getAll():Observable<AccreditationDto[]>{
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.getTyped<AccreditationDto[]>(baseUrl))
    );
  }

  public getAllRequireAccreditation():Observable<AccreditationDto[]>{
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.getTyped<AccreditationDto[]>(`${baseUrl}/require-accreditation`))
    );
  }

  public updateResourceIdAndPendingStatus(model:AccreditationDto):Observable<AccreditationDto>{
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.postTyped<AccreditationDto>(`${baseUrl}/pending`, model))
    );
  }

  public updateViewInvestorStatus(model:AccreditationDto):Observable<AccreditationDto>{
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.postTyped<AccreditationDto>(`${baseUrl}/viewed`, model))
    );
  }

  public downloadAccreditationCertificate(investingEntityId:number, accreditationId:number):Observable<any>{
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.downloadFile(`${baseUrl}/${investingEntityId}/download-certificate/${accreditationId}`,'application/pdf'))
    );
  }
}
